import { render } from "./SalesOrderDetailPopUp.vue?vue&type=template&id=4da7c2de"
import script from "./SalesOrderDetailPopUp.vue?vue&type=script&lang=js"
export * from "./SalesOrderDetailPopUp.vue?vue&type=script&lang=js"

import "./SalesOrderDetailPopUp.vue?vue&type=style&index=0&id=4da7c2de&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__